import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const AddCustomer = () => {
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        area: '',
        pin_code: '',
        state: '',
        city: '',
        firm_name: '',
        number1: '',
        number2: '',
        number3: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        // Send POST request to add customer
        fetch(`${BASE_URL}customers`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    // Successfully created customer, redirect to customer list
                    navigate('/CustomerList');
                } else {
                    setError(data.message || 'Failed to add customer');
                }
            })
            .catch(err => {
                setError('Error occurred while adding customer');
                console.error('Error adding customer:', err);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Customer</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Customer Information</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {error && <div className="alert alert-danger">{error}</div>}
                                      <div className="mb-3">
                                        <label htmlFor="firm_name" className="form-label">Firm Name </label>
                                        <input
                                            type="text"
                                            id="firm_name"
                                            required
                                            name="firm_name"
                                            className="form-control"
                                            placeholder="Enter firm name"
                                            value={formData.firm_name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Owner Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className="form-control"
                                            placeholder="Enter Owner name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                     <div className="mb-3">
                                        <label htmlFor="area" className="form-label">Area</label>
                                        <input
                                            type="text"
                                            id="area"
                                            name="area"
                                            className="form-control"
                                            placeholder="Enter customer area"
                                            value={formData.area}
                                            onChange={handleChange}
                                        />
                                    </div>
                                     <div className="mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input
                                            type="text"
                                            id="city"
                                            name="city"
                                            className="form-control"
                                            placeholder="Enter customer city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="pin_code" className="form-label">Pin Code</label>
                                        <input
                                            type="text"
                                            id="pin_code"
                                            name="pin_code"
                                            className="form-control"
                                            placeholder="Enter customer pin code"
                                            value={formData.pin_code}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
  <div className="mb-3">
                                        <label htmlFor="state" className="form-label">State</label>
                                        <input
                                            type="text"
                                            id="state"
                                            name="state"
                                            className="form-control"
                                            placeholder="Enter customer state"
                                            value={formData.state}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    

                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            id="address"
                                            name="address"
                                            className="form-control"
                                            placeholder="Enter customer address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                   

                                    

                                  

                                   

                                  

                                    <div className="mb-3">
                                        <label htmlFor="number1" className="form-label">Owner Phone Number </label>
                                       <input
    type="text" // Use text type to control the input more easily
    id="number1"
    name="number1"
    className="form-control"
    placeholder="Enter phone number 1"
    value={formData.number1}
    onChange={(e) => {
        const value = e.target.value;

        // Ensure only digits (0-9) and limit input length to 10 digits
        if (/^\d{0,10}$/.test(value)) {
            handleChange(e); // Update state if value is valid (only digits and max length 10)
        }
    }}
    required
    maxLength={10} // Restrict input to a maximum of 10 digits
/>

                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="number2" className="form-label">Office Number 2 (Optional)</label>
                                       <input
    type="text"
    id="number2"
    name="number2"
    className="form-control"
    placeholder="Enter phone number 2"
    value={formData.number2}
    onChange={(e) => {
        const value = e.target.value;

        // Ensure only digits (0-9) and a maximum length of 10 digits
        if (/^\d{0,10}$/.test(value)) {
            handleChange(e); // Update state if the value is valid
        }
    }}
    required
    maxLength={10} // Restrict input to a maximum of 10 digits
/>

                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="number3" className="form-label">Account Number</label>
                                        <input
    type="text"
    id="number3"
    name="number3"
    className="form-control"
    placeholder="Enter phone number 3"
    value={formData.number3}
    onChange={(e) => {
        const value = e.target.value;

        // Allow only digits (0-9) and ensure the length is 10
        if (/^\d{0,10}$/.test(value)) {
            handleChange(e); // Update state only if the value is valid
        }
    }}
    required
    maxLength={10} // Restrict input length to a maximum of 10 digits
/>

                                    </div>

                                    <div className="mb-3 text-end">
                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                            {loading ? 'Submitting...' : 'Add Customer'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddCustomer;
